export default "__VITE_ASSET__78e90fde__"